/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantMinimalDto } from './TenantMinimalDto';
import {
    TenantMinimalDtoFromJSON,
    TenantMinimalDtoFromJSONTyped,
    TenantMinimalDtoToJSON,
    TenantMinimalDtoToJSONTyped,
} from './TenantMinimalDto';

/**
 * 
 * @export
 * @interface GetRealEstateTenantsResponse
 */
export interface GetRealEstateTenantsResponse {
    /**
     * 
     * @type {Array<TenantMinimalDto>}
     * @memberof GetRealEstateTenantsResponse
     */
    tenants?: Array<TenantMinimalDto>;
}

/**
 * Check if a given object implements the GetRealEstateTenantsResponse interface.
 */
export function instanceOfGetRealEstateTenantsResponse(value: object): value is GetRealEstateTenantsResponse {
    return true;
}

export function GetRealEstateTenantsResponseFromJSON(json: any): GetRealEstateTenantsResponse {
    return GetRealEstateTenantsResponseFromJSONTyped(json, false);
}

export function GetRealEstateTenantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRealEstateTenantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenants': json['tenants'] == null ? undefined : ((json['tenants'] as Array<any>).map(TenantMinimalDtoFromJSON)),
    };
}

export function GetRealEstateTenantsResponseToJSON(json: any): GetRealEstateTenantsResponse {
    return GetRealEstateTenantsResponseToJSONTyped(json, false);
}

export function GetRealEstateTenantsResponseToJSONTyped(value?: GetRealEstateTenantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenants': value['tenants'] == null ? undefined : ((value['tenants'] as Array<any>).map(TenantMinimalDtoToJSON)),
    };
}

